/**
 * 审批状态的枚举配置，
 * 1  - 待审批
 * 2  - 已审批
 * 3  - 已驳回
 * 4  - 已完成
 * 5  - 即将休假
 * 6  - 正在休假
 * 7  - 销假逾期
 * 9  - 无人自动通过
 * 10 - 逾期自动驳回
 */

export const STATUS = {
  PENDING: '1', // 待审批
  PROCESSING: '2', // 已审批
  REJECT: '3', // 已拒绝 (驳回)
  COMPLETE: '4', // 已完成 (销假成功)
  READY: '5', // 即将休假
  HOLIDAY: '6', // 休假中
  EXCEED: '7', // 销假逾期
  AUTO_PASS: '9', // 当前流程节点没有老师，直接审批通过
  AUTO_REJECT: '10', // 未审批逾期30天自动驳回
}

export const STATUS_CONF = {
  [STATUS.PENDING]: {
    name: '待审批', // 从审批人的角度显示状态
    requestStatus: '申请提交成功', // 从提交人的角度显示状态
    cls: 'common-happy',
    approveStatus: '待审批', // pc端审批状态
  },
  [STATUS.PROCESSING]: {
    name: '审批通过',
    requestStatus: '审批已通过',
    cls: 'common-laughter',
    approveStatus: '批准',
  },
  [STATUS.REJECT]: {
    name: '已驳回',
    requestStatus: '审批已驳回',
    cls: 'common-sad',
    approveStatus: '驳回',
  },
  [STATUS.COMPLETE]: {
    name: '已完成',
    requestStatus: '审批已通过',
    cls: 'common-laughter',
    approveStatus: '批准',
  },
  [STATUS.READY]: {
    name: '即将休假',
    requestStatus: '即将休假',
    cls: 'common-laughter',
    approveStatus: '即将休假',
  },
  [STATUS.HOLIDAY]: {
    name: '正在休假中',
    requestStatus: '正在休假中',
    cls: 'common-laughter',
    approveStatus: '正在休假中',
  },
  [STATUS.EXCEED]: {
    name: '销假逾期',
    requestStatus: '销假逾期',
    cls: 'common-laughter',
    approveStatus: '销假逾期',
  },
  [STATUS.AUTO_PASS]: {
    name: '审批通过',
    requestStatus: '审批已通过',
    cls: 'common-laughter',
    approveStatus: '批准',
  },
  [STATUS.AUTO_REJECT]: {
    name: '逾期自动驳回',
    requestStatus: '审批已驳回',
    cls: 'common-sad',
    approveStatus: '驳回',
  },
}

export const getStatusCls = (status) => {
  return (STATUS_CONF[status] && STATUS_CONF[status].cls) || ''
}

export const getStatusName = (status) => {
  return (STATUS_CONF[status] && STATUS_CONF[status].name) || ''
}

export const getRequestStatusName = (status) => {
  return (STATUS_CONF[status] && STATUS_CONF[status].requestStatus) || ''
}

export const getApproveStatusName = (status) => {
  return (STATUS_CONF[status] && STATUS_CONF[status].approveStatus) || ''
}

/**
 * 是否离校
 */
const OUT_STATUS = {
  ON: true,
  OFF: false,
}

export const outStatusConf = {
  [OUT_STATUS.ON]: {
    name: '离校',
    cls: 'has_left',
    value: true,
  },
  [OUT_STATUS.OFF]: {
    name: '否',
    cls: 'un_left',
    value: false,
  },
}
export const outSchoolOpts = [
  {
    name: '离校',
    cls: 'has_left',
    value: true,
  },
  {
    name: '否',
    cls: 'un_left',
    value: false,
  },
]

// 请假天数
export const leaveDays = [
  {
    id: 0,
    name: '全部',
    selected: true,
  },
  {
    id: 1,
    name: '一天以内',
    selected: false,
  },
  {
    id: 2,
    name: '一到三天',
    selected: false,
  },
  {
    id: 3,
    name: '三天以上',
    selected: false,
  },
]

// 请假状态
export const statusTags = [
  {
    id: 0,
    name: '全部',
    selected: true,
  },
  {
    id: STATUS.EXCEED,
    name: '销假逾期',
    selected: false,
  },
  {
    id: STATUS.READY,
    name: '即将休假',
    selected: false,
  },
  {
    id: STATUS.HOLIDAY,
    name: '正在休假中',
    selected: false,
  },
]

/**
 * 提前结束信息
 */
export const TERMINATION_STATUS = {
  // 是否可提前结束
  ALLOW_TERMINATE: {
    YES: 1,
    NO: 0,
  },

  // 是否已经提前结束
  TERMINATED: {
    YES: 1,
    NO: 0,
  },
}
